import type { ProjectScope } from './project-scope';

const pendingLineNoteDeleteKeys = new Set<string>();

function lineNoteWriteKey(scope: ProjectScope, lineNoteId: string): string {
    return `${scope.orgId}\0${scope.projectId}\0${lineNoteId}`;
}

function lineNoteWritePrefix(scope: ProjectScope): string {
    return `${scope.orgId}\0${scope.projectId}\0`;
}

export function markPendingLineNoteDelete(scope: ProjectScope, lineNoteId: string): void {
    pendingLineNoteDeleteKeys.add(lineNoteWriteKey(scope, lineNoteId));
}

export function clearPendingLineNoteDelete(scope: ProjectScope, lineNoteId: string): void {
    pendingLineNoteDeleteKeys.delete(lineNoteWriteKey(scope, lineNoteId));
}

export function isPendingLineNoteDelete(scope: ProjectScope, lineNoteId: string): boolean {
    return pendingLineNoteDeleteKeys.has(lineNoteWriteKey(scope, lineNoteId));
}

export function clearAcknowledgedPendingLineNoteDeletes(
    scope: ProjectScope,
    remoteLineNoteIds: ReadonlySet<string>
): void {
    const prefix = lineNoteWritePrefix(scope);
    for (const key of Array.from(pendingLineNoteDeleteKeys)) {
        if (!key.startsWith(prefix)) continue;
        const lineNoteId = key.slice(prefix.length);
        if (!remoteLineNoteIds.has(lineNoteId)) {
            pendingLineNoteDeleteKeys.delete(key);
        }
    }
}

export function clearPendingLineNoteWrites(): void {
    pendingLineNoteDeleteKeys.clear();
}
